/*
 * @Description: h5路由列表
 * @Author: victor
 * @Date: 2021-06-30 08:43:17
 * @LastEditTime: 2024-04-16 09:59:12
 * @LastEditors: jayne(罗敬)
 */
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },{
      path: '/notificationTest',//四个按钮测试mqtt页面 -罗敬
      name: 'notificationTest',
      component: () =>import('../views/notificationTest/notificationTest_index.vue')
    }, {
      path: '/JY02', //JY02_H5公共卫生首页-罗敬
      name: 'JY02',
      component: () => import('../views/JY02/familyDoctor/main_index.vue'),
      meta: {
        title: 'JY02公共卫生菜单及右侧框架',
        requireAuth: true
      },
      children: [{
        path: 'mainPage', //JY02_H5公共卫生首页-罗敬
        name: 'mainPage',
        component: () => import('../views/JY02/familyDoctor/mainPage/mainPage_index.vue'),
        meta: {
          title: 'JY02公共卫生首页',
          requireAuth: true
        },
      }, {
        path: 'putInAFile', //JY02公共卫生建档-查询-杨帅
        name: 'putInAFile',
        component: () => import('../views/JY02/familyDoctor/putInAFile/putInAFile_index.vue'),
        meta: {
          title: 'JY02公共卫生档案查询',
          requireAuth: true
        },
      }, {
        path: 'createRecord', //JY02公共卫生建档-创建-杨帅
        name: 'createRecord',
        component: () => import('../views/JY02/familyDoctor/putInAFile/basicInfo.vue'),
        meta: {
          title: 'JY02公共卫生居民档案创建',
          requireAuth: true
        },
      }, {
        path: 'createRecordResult', //JY02公共卫生建档-创建结果-杨帅
        name: 'createRecordResult',
        component: () => import('../views/JY02/familyDoctor/putInAFile/putResult.vue'),
        meta: {
          title: 'JY02公共卫生居民档案创建结果',
          requireAuth: true
        },
      }, {
        path: 'signAContract', //JY02公共卫生签约-罗敬
        name: 'signAContract',
        component: () => import('../views/JY02/familyDoctor/signAContract/signAContract_index.vue'),
        meta: {
          title: 'JY02公共卫生签约',
          requireAuth: true
        },
      }, {
        path: 'education', //JY02_H5公共卫生教育-罗敬
        name: 'education',
        component: () => import('../views/JY02/familyDoctor/education/education_index.vue'),
        meta: {
          title: 'JY02公共卫生教育',
          requireAuth: true
        },
      }, {
        path: 'edItem', //JY02_H5公共卫生教育-罗敬
        name: 'edItem',
        component: () => import('../views/JY02/familyDoctor/education/edItem.vue'),
        meta: {
          title: 'JY02教育详情',
          requireAuth: true
        },
      }, {
        path: 'residentFiles', //JY02公共卫生居民档案-杨帅
        name: 'residentFiles',
        component: () => import('../views/JY02/familyDoctor/residentFiles/residentFiles_index.vue'),
        meta: {
          title: 'JY02公共卫生居民档案',
          requireAuth: true
        },
      }, {
        path: 'elderlySelfCareAbilityForm', //JY02公共卫生居民档案-健康体检表-老年人生活自理能力评估表-杨帅
        name: 'elderlySelfCareAbilityForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/elderlySelfCareAbilityForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案健康体检老年人生活自理能力评估表',
          requireAuth: true
        },
      }, {
        path: 'physicalExaminationForm', //JY02公共卫生居民档案-健康体检表-杨帅
        name: 'physicalExaminationForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/physicalExaminationForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案健康体检表',
          requireAuth: true
        },
      }, {
        path: 'receptionRecordForm', //JY02公共卫生居民档案-接诊记录表-杨帅
        name: 'receptionRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/receptionRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案接诊记录表',
          requireAuth: true
        },
      }, {
        path: 'consultationRecordForm', //JY02公共卫生居民档案-会诊记录表-杨帅
        name: 'consultationRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/consultationRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案会诊记录表',
          requireAuth: true
        },
      }, {
        path: 'hypertensionRecordForm', //JY02公共卫生居民档案-高血压患者随访服务记录表-杨帅
        name: 'hypertensionRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/hypertensionRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案高血压患者随访服务记录表',
          requireAuth: true
        },
      }, {
        path: 'oldPeopleHealthForm', //JY02公共卫生居民档案-老年人中医药健康管理服务记录表-杨帅
        name: 'oldPeopleHealthForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/oldPeopleHealthForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案老年人中医药健康管理服务记录表',
          requireAuth: true
        },
      },{
        path: 'childrenHealthForm', //JY02公共卫生居民档案-儿童中医药健康管理服务记录表-杨帅
        name: 'childrenHealthForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/childrenHealthForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案儿童中医药健康管理服务记录表',
          requireAuth: true
        },
      }, {
        path: 'oldPeopleHealthEvaluationResultsForm', //JY02公共卫生居民档案-老年人中医药健康管理服务记录表-评测结果-杨帅
        name: 'oldPeopleHealthEvaluationResultsForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/oldPeopleHealthEvaluationResultsForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案老年人中医药健康管理服务记录表-评测结果',
          requireAuth: true
        },
      }, {
        path: 'psychosisRecordForm', //JY02公共卫生居民档案-严重精神病患者管理记录表-杨帅
        name: 'psychosisRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/psychosisRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案严重精神病患者管理记录表',
          requireAuth: true
        },
      }, {
        path: 'psychosisSupplementRecordForm', //JY02公共卫生居民档案-严重精神障碍患者个人信息补充表-杨帅
        name: 'psychosisSupplementRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/psychosisSupplementRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案严重精神障碍患者个人信息补充表',
          requireAuth: true
        },
      }, {
        path: 'tuberculosisFirstRecordForm', //JY02公共卫生居民档案-肺结核患者第一次入户随访记录表-杨帅
        name: 'tuberculosisFirstRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/tuberculosisFirstRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案肺结核患者第一次入户随访记录表',
          requireAuth: true
        },
      }, {
        path: 'tuberculosisRecordForm', //JY02公共卫生居民档案-肺结核患者随访服务记录表-杨帅
        name: 'tuberculosisRecordForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/tuberculosisRecordForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案肺结核患者随访服务记录表',
          requireAuth: true
        },
      }, {
        path: 'antenatalForm', //JY02公共卫生居民档案-产前检查服务记录表-杨帅
        name: 'antenatalForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/antenatalForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案产前检查服务记录表',
          requireAuth: true
        },
      }, {
        path: 'postpartumForm', //JY02公共卫生居民档案-产后检查服务记录表-杨帅
        name: 'postpartumForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/postpartumForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案产后检查服务记录表',
          requireAuth: true
        },
      }, {
        path: 'newbornForm', //JY02公共卫生居民档案-新生儿家庭访视记录表-杨帅
        name: 'newbornForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/newbornForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案新生儿家庭访视记录表',
          requireAuth: true
        },
      }, {
        path: 'childrenForm', //JY02公共卫生居民档案-儿童健康检查记录表-杨帅
        name: 'childrenForm',
        component: () => import('../views/JY02/familyDoctor/residentFiles/comms/childrenForm.vue'),
        meta: {
          title: 'JY02公共卫生居民档案儿童健康检查记录表',
          requireAuth: true
        },
      }, {
        path: 'recordIndex', //公共服务/家医履约--记录表与签约信息记录主页-杨帅
        name: 'recordIndex',
        component: () => import('../views/JY02/familyDoctor/residentFiles/recordIndex.vue'),
        meta: {
          title: 'JY02公共卫生居民档案记录表与签约信息记录主页',
          requireAuth: true
        },
      }]
    }, {
      path: '/appDownload', //MobileH5页面--小域精灵app --罗敬
      name: 'appDownload',
      component: () => import('../views/appDownload/yuApp.vue'),
      meta: {
        title: '小域精灵',
        requireAuth: true
      },
    }, {
      path: '/safetyRun', //MobileH5页面--华体马拉松app --罗敬
      name: 'safetyRun',
      component: () => import('../views/appDownload/HT/safetyRun.vue'),
      meta: {
        title: '下载',
        requireAuth: true
      },
    }, {
      path: '/safetyRunTest', //MobileH5页面--华体马拉松app 测试页面 --罗敬
      name: 'safetyRunTest',
      component: () => import('../views/appDownload/HT/safetyRunTest.vue'),
      meta: {
        title: '下载',
        requireAuth: true
      },
    },{
      path: '/download', //安心跑下载页面通用-- --罗敬
      name: 'download',
      component: () => import('../views/appDownload/HT/download.vue'),
      meta: {
        title: '下载',
        requireAuth: true
      },
    },{
      path: '/downloadTest', //安心跑下载页面通用-- --罗敬
      name: 'downloadTest',
      component: () => import('../views/appDownload/HT/downloadTest.vue'),
      meta: {
        // title: '下载',
        requireAuth: true
      },
    },
    {
      path: '/huaTiApp', //MobileH5页面--华体马拉松app --罗敬
      name: 'huaTiApp',
      component: () => import('../views/appDownload/HT/huaTiApp.vue'),
      meta: {
        title: '下载',
        requireAuth: true
      },
    }, {
      path: '/userAgreement', //MobileH5页面--华体马拉松app 用户协议--罗敬
      name: 'userAgreement',
      component: () => import('../views/appDownload/HT/userAgreement.vue'),
      meta: {
        title: '用户协议',
        requireAuth: true
      },
    },{
      path: '/JYuserAgreement', //MobileH5页面--疆域健康软件许可及服务协议--Grimm
      name: 'JYuserAgreement',
      component: () => import('../views/appDownload/HT/JYuserAgreement.vue'),
      meta: {
        title: '疆域健康软件许可及服务协议',
        requireAuth: true
      },
    },{
      path: '/JYWuserAgreement', //MobileH5页面--虎耀健康软件许可及服务协议--Grimm
      name: 'JYWuserAgreement',
      component: () => import('../views/appDownload/HT/JYWuserAgreement.vue'),
      meta: {
        title: '疆域健康软件许可及服务协议',
        requireAuth: true
      },
    }, {
      path: '/privacyAgreement', //MobileH5页面--华体马拉松app 安心跑隐私政策--罗敬
      name: 'privacyAgreement',
      component: () => import('../views/appDownload/HT/privacyAgreement.vue'),
      meta: {
        title: '安心跑隐私政策',
        requireAuth: true
      },
    },
    {
      path: '/homeTfdaPrivacyAgreement', //MobileH5页面--CoDoctor Home 隱私政策 虎耀云--罗敬
      name: 'homeTfdaPrivacyAgreement',
      component: () => import('../views/appDownload/HT/homeTfdaPrivacyAgreement.vue'),
      meta: {
        title: 'CoDoctor Home隱私政策',
        requireAuth: true
      },
    },{
      path: '/homeTfdaUserAgreement', //MobileH5页面--CoDoctor Home 軟體授權及服務條款 虎耀云--罗敬
      name: 'homeTfdaUserAgreement',
      component: () => import('../views/appDownload/HT/homeTfdaUserAgreement.vue'),
      meta: {
        title: 'CoDoctor Home軟體授權及服務條款',
        requireAuth: true
      },
    },
    {
      path: '/JYprivacyAgreement', //MobileH5页面--疆域健康隐私政策--Grimm
      name: 'JYprivacyAgreement',
      component: () => import('../views/appDownload/HT/JYprivacyAgreement.vue'),
      meta: {
        title: '疆域健康隐私政策',
        requireAuth: true
      },
    },{
      path: '/JYWprivacyAgreement', //MobileH5页面--虎耀健康隐私政策--Grimm
      name: 'JYWprivacyAgreement',
      component: () => import('../views/appDownload/HT/JYWprivacyAgreement.vue'),
      meta: {
        title: '疆域健康隐私政策',
        requireAuth: true
      },
    }, {
      path: '/huaWeiSet', //MobileH5页面--华体马拉松白名单华为--罗敬
      name: 'huaWeiSet',
      component: () => import('../views/appDownload/HT/whiteListSet/huaWeiSet.vue'),
      meta: {
        title: '电池白名单设置',
        requireAuth: true
      },
    }, {
      path: '/oppoSet', //MobileH5页面--华体马拉松华体马拉松白名单oppo--罗敬
      name: 'oppoSet',
      component: () => import('../views/appDownload/HT/whiteListSet/oppoSet.vue'),
      meta: {
        title: '电池白名单设置',
        requireAuth: true
      },
    }, {
      path: '/samsungSet', //MobileH5页面--华体马拉松华体马拉松白名单三星--罗敬
      name: 'samsungSet',
      component: () => import('../views/appDownload/HT/whiteListSet/samsungSet.vue'),
      meta: {
        title: '电池白名单设置',
        requireAuth: true
      },
    },
    {
      path: '/productUse', //MobileH5页面--公司简介 --王成宇
      name: 'productUse',
      component: () => import('../views/officialAccount/productUse.vue'),
      meta: {
        title: '产品使用',
        requireAuth: true
      },
    },
    {
      path: '/videoPlayer', //MobileH5页面--公司简介 --王成宇
      name: 'videoPlayer',
      component: () => import('../views/officialAccount/videoPlayer.vue'),
      meta: {
        title: '播放视频',
        requireAuth: true
      },
    },
    {
      path: '/aboutCompany', //MobileH5页面--公司简介 --王成宇
      name: 'aboutCompany',
      component: () => import('../views/officialAccount/aboutCompany.vue'),
      meta: {
        title: '公司简介',
        requireAuth: true
      },
    },
    {
      path: '/contactUs', //MobileH5页面--联系我们 --王成宇
      name: 'contactUs',
      component: () => import('../views/officialAccount/contactUs.vue'),
      meta: {
        title: '联系我们',
        requireAuth: true
      },
    },
    {
      path: '/caseCommunication', //MobileH5页面--案例交流 --王成宇
      name: 'caseCommunication',
      component: () => import('../views/officialAccount/caseCommunication.vue'),
      meta: {
        title: '案例交流',
        requireAuth: true
      },
    },
    {
      path: '/doctorCourse', //MobileH5页面--医生讲堂 --王成宇
      name: 'doctorCourse',
      component: () => import('../views/officialAccount/doctorCourse.vue'),
      meta: {
        title: '医生讲堂',
        requireAuth: true
      },
    },
    {
      path: '/healthData', //MobileH5页面--健康数据 --王成宇
      name: 'healthData',
      component: () => import('../views/officialAccount/healthData.vue'),
      meta: {
        title: '健康数据',
        requireAuth: true
      },
    },
    {
      path: '/serviceList', //MobileH5页面--售后服务 --王成宇
      name: 'serviceList',
      component: () => import('../views/officialAccount/serviceList.vue'),
      meta: {
        title: '售后服务列表',
        requireAuth: true
      },
    },
    {
      path: '/serviceIndex', //MobileH5页面--售后服务首页 --王成宇
      name: 'serviceIndex',
      component: () => import('../views/officialAccount/serviceIndex.vue'),
      meta: {
        title: '售后服务首页',
        requireAuth: true
      },
    },
    {
      path: '/priceList', //MobileH5页面--硬件维修价格表 --王成宇
      name: 'priceList',
      component: () => import('../views/officialAccount/priceList.vue'),
      meta: {
        title: '硬件维修价格列表',
        requireAuth: true
      },
    },
    {
      path: '/questionDetail', //MobileH5页面--问题详情及解决方案 --王成宇
      name: 'questionDetail',
      component: () => import('../views/officialAccount/questionDetail.vue'),
      meta: {
        title: '问题详情及解决方案',
        requireAuth: true
      },
    },
    {
      path: '/examUserAgreement', //体检预约用户协议 -- 罗敬
      name: 'examUserAgreement',
      component: () => import('@/views/agreement/examUserAgreement.vue'),
      meta: {
        title: '体检预约用户协议',
        requireAuth: true
      },
    },
    {
      path: '/examPrivacyAgreement', //体检预约隐私协议 -- 罗敬
      name: 'examPrivacyAgreement',
      component: () => import('@/views/agreement/examPrivacyAgreement.vue'),
      meta: {
        title: '体检预约隐私协议',
        requireAuth: true
      },
    },
    {
      path: '/WordToHtml', //word转html
      name: 'WordToHtml',
      component: () => import('@/views/agreement/word_to_html.vue'),
      meta: {
        title: '转',
        requireAuth: true
      },
    },
    {
      path: '/miniProgramPrivacyAgreement', //疆域健康管理系统隐私政策
      name: 'miniProgramPrivacyAgreement',
      component: () => import('@/views/agreement/miniProgramPrivacyAgreement.vue'),
      meta: {
        title: '疆域健康管理系统隐私政策',
        requireAuth: true
      },
    },
    {
      path: '/miniProgramUserAgreement', //疆域健康管理系统许可及服务协议
      name: 'miniProgramUserAgreement',
      component: () => import('@/views/agreement/miniProgramUserAgreement.vue'),
      meta: {
        title: '疆域健康管理系统许可及服务协议',
        requireAuth: true
      },
    },
    { 
      path: '/germanyPrivacyAgreement', //德国Medion工程版本隐私协议-王成宇
      name: 'germanyPrivacyAgreement',
      component: () => import('@/views/germany/privacyAgreement.vue'),
      meta: {
        title: 'Privacy Policy',
        requireAuth: true
      },
    },
    {
      path: '/germanyServiceTerms', //德国Medion工程版本服务条款-王成宇
      name: 'germanyServiceTerms',
      component: () => import('@/views/germany/serviceTerms.vue'),
      meta: {
        title: 'Service Agreement',
        requireAuth: true
      },
    },
    {
      path: '/universalAgreement', //通用带历史记录的服务条款和隐私协议-王成宇
      name: 'universalAgreement',
      component: () => import('@/views/universalAgreement/index.vue'),
      meta: {
        title: 'Service Agreement',
        requireAuth: true
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js